import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../flights/overview/ui/list/columns/Column';
import { Responsive } from '../../../../ui';
import { columnHeaderStyles } from './shared';

interface IPolicyNameCellProps {
	title: string;
}

const styles = css`
	display: flex;
	flex: 2;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: none;
	}
`;

const StyledHeader = styled(BaseHeader)`
	${styles}
	${columnHeaderStyles}
`;

const StyledCell = styled(BaseCell)`
	${styles}
	font-weight: 500;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: name;
	}
`;

export function Header() {
	return <StyledHeader>Name</StyledHeader>;
}

export function Cell({ title }: IPolicyNameCellProps) {
	return <StyledCell>{title}</StyledCell>;
}
